import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=15b1cc87&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=15b1cc87&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1cc87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b1cc87')) {
      api.createRecord('15b1cc87', component.options)
    } else {
      api.reload('15b1cc87', component.options)
    }
    module.hot.accept("./Tenants.vue?vue&type=template&id=15b1cc87&scoped=true", function () {
      api.rerender('15b1cc87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/Tenants.vue"
export default component.exports